"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/features/promise");
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @name expireUnauthorizedCookies
 * @description sends request to cookie scrubbing service to remove unauthorized cookies.
 */
var _default = exports.default = function _default() {
  return (0, _isomorphicFetch.default)('/nui/signin/scrub-cookies', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    },
    credentials: 'include'
  }).then(function (res) {
    return res.json();
  }).catch(function () {
    /* swallow */
  });
};